import styled from 'styled-components'
import Confetti from '../../assets/img/gcash/Bitmap@1x.png'
import media from '../../services/generateMediaQueries'

export const MainContainer = styled.div`
min-height: 100vh
display: flex;
flex-direction: column;
  ${media.greaterThan('small')`
    min-width: 50vh;
    max-width: 600px;
    margin: auto;
  `}
`
export const ContentContainer = styled.div`
  padding: 1.2rem;
  padding-top: 0;
  text-align: center;
  flex-grow: 1;
`
export const BannerImage = styled.img`
  min-height: 200px;
  width: 100%;
`
export const Title = styled.h2``
export const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: var(--letter-spacing-narrower);
  text-align: center;
  margin: 0;
`
export const CodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
export const PromoCode = styled.h1`
  font-size: 40px;
  color: var(--color-primary);
  margin: 0.5em 0;
`
export const Copy = styled.div`
  background-color: var(--color-primary);
  padding: 0.4rem;
  border-radius: 50%;
  margin-left: 0.2rem;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`
export const StoreBubbles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
export const Store = styled.img`
  cursor: pointer;
  height: 39px;

  &:first-child {
    margin-right: 1.1875rem;
  }
`
export const Instructions = styled.div`
  border-radius: 8px;
  background-color: rgba(216, 216, 216, 0.3);
  padding: 1.6rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: var(--letter-spacing-narrower);
  margin-bottom: 2rem;
`
export const InstructionsTitle = styled.b``
export const InstructionsList = styled.ol`
  padding-inline-start: 0.875rem;
`
export const InstructionsListItem = styled.li``
export const InstructionsValidity = styled.b`
  font-style: italic;
`
export const DownloadLabel = styled.p`
  font-weight: bold;
`
export const TncLink = styled.a`
  text-decoration: none;
`
export const Footer = styled.div`
background: url('${Confetti}');
text-align: center;
font-size: 0.875rem;
padding: 0 2rem;
padding-top: 0;
background-size: contain;
background-position: bottom;
color: var(--color-fg-light);
background-repeat: no-repeat;
`
export const HiddenInput = styled.input`
  position: absolute;
  top: -999999%;
  left: -999999%;
`
export const SpinnerContainer = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: center;
`
export const FlexWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;
  min-height: 480px;
  padding: 2rem;
  margin: auto;
  max-width: 480px;
`
export const StyledImage = styled.img`
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`
